// i18n area 'common' — locale tr-TR (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.tr-TR.meta.json.
import type { enUS } from './common'

export const trTR: typeof enUS = {
  nav: {
    home: 'Home',
    vms: 'Sanal makineler',
    templates: 'Şablonlar',
    importVms: "VM'leri içe aktar",
    containers: 'Konteynerler',
    containersApps: "App'ler",
    containersPods: 'Pod’lar',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI görüntüleri',
    containersOciRegistries: "OCI registry'leri",
    containersCtTemplates: 'CT şablonları',
    networkServices: 'Ağ hizmetleri',
    firewall: 'Güvenlik duvarı',
    checkpoints: 'Checkpointler',
    backup: 'Yedekleme',
    monitoring: 'İzleme',
    cluster: 'Küme',
    clusterSettings: 'Genel ayarlar',
    clusterNodes: 'Düğümler',
    clusterDevices: 'USB ve PCIe kaynakları',
    clusterFederation: 'Federasyon',
    network: 'Ağ',
    overlayNetworks: 'Overlay ağları',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Depolama',
    data: 'Veri',
    storages: 'Depolama',
    hci: 'Hiperbütünleşik altyapı',
    ceph: 'Ceph',
    system: 'Sistem',
    tasks: 'Görevler',
    events: 'Olaylar',
    audit: 'Denetim',
    diagnostics: 'Tanılama',
    notifications: 'Bildirimler',
    proximity: 'TVirt Proximity',
    users: 'Kullanıcılar ve gruplar',
    groups: 'Gruplar',
    mfa: 'MFA',
    realms: "Realm'ler ve SSO",
    rbac: 'Roller ve izinler',
    credentials: 'Kimlik bilgileri',
    scopes: "Scope'lar",
    tags: 'Etiketler',
    explorer: 'Keşfet',
    licensing: 'Lisans',
    information: 'Bilgiler'
  },
  mode: {
    light: 'Açık',
    dark: 'Koyu',
    system: 'Sistem',
    tooltip: 'Tema'
  },
  language: {
    tooltip: 'Dil'
  },
  langRegion: {
    europe: 'Avrupa',
    northAmerica: 'Kuzey Amerika',
    southAmerica: 'Güney Amerika',
    asia: 'Asya'
  },
  notFound: {
    title: 'Sayfa bulunamadı',
    body: 'Bu adres hiçbir TVirt sayfasına karşılık gelmiyor — bir güncellemeyle taşınmış olabilir ya da link eskimiş.',
    backHome: "Home'a dön"
  },
  scopeBrowser: {
    title: "Scope'lar",
    all: 'Tüm küme',
    noChildren: 'Burada alt scope yok',
    recursive: "Alt scope'ları dahil et",
    collapse: 'Scope panelini daralt',
    openPicker: "Scope'lara göz at",
    up: 'Bir üst düzeye çık',
    countTooltip: "{direct} bu scope'ta · {total} alt scope'larla birlikte"
  },
  search: {
    tooltip: 'Ara (⌘K)',
    placeholder: 'VM, ağ, depolama ara…',
    empty: 'Sonuç yok',

    // Round command palette (#221).
    groups: {
      recent: 'Son kullanılanlar',
      shortcuts: 'Kısayollar',
      actions: 'Eylemler',
      goTo: 'Git'
    },
    kind: {
      catalog: 'Katalog',
      scope: 'Scope',
      node: 'Düğüm'
    },
    footer: {
      navigate: 'gezin',
      open: 'aç',
      close: 'kapat'
    },
    actions: {
      createVm: 'VM oluştur…',
      uploadIso: 'ISO karşıya yükle…',
      clusterSettings: 'Küme ayarları',
      consoleOf: '{name} konsoluna git'
    }
  },
  stub: {
    containersSummary: "Uygulamalar ve sistem konteynerleri (CT); OCI görüntüleri, registry'leri ve şablonlarıyla — VM'lerinizin yanında yönetilir.",
    sectionSummary_vms: 'Sanal makineler ve şablonları — yaşam döngüsü, anlık görüntüler, geçiş ve konsollar.',
    sectionSummary_storages: 'Disklerin, görüntülerin ve VM meta verilerinin yaşadığı depolama havuzları.',
    sectionSummary_catalogs: 'Kümenin dosya yapıtlarının evi: ISO görüntüleri, CT ve VM şablonları ve OCI arşivleri, kataloglar halinde düzenlenmiş.',
    sectionSummary_overlay: 'Küme düğümleri arasında VXLAN overlay ağları.',
    sectionSummary_fabric: "Fiziksel ağ envanteri — anahtarlar, portlar, LAGG'ler ve mantıksal ağlar.",
    sectionSummary_ipam: 'Fabric ve overlay ağlarından türetilen adresleme: her adresi kimin tuttuğu.',
    sectionSummary_services: 'Ağ kaydından türetilen DHCP ve DNS sunucuları.',
    sectionSummary_ceph: 'TVirt düğümlerinde yönetilen Ceph kümeleri.',
    sectionSummary_hci: 'TVirt düğümlerindeki hiperbütünleşik depolama teknolojileri.',
    sectionSummary_cluster: 'Düğümler, üyelik ve küme ayarları.',
    containers: 'Sistem konteynerleri yol haritasında — bu bölüm onları barındıracak.',
    containersApps: 'Konteynerleştirilmiş uygulamalar yol haritasında — bu alan onları barındıracak.',
    containersPods: 'Pod’lar ağı ve birimleri paylaşan konteynerleri gruplar — örnekler uygulamalardır.',
    containersCt: 'Sistem konteynerleri (CT) yol haritasında — bu alan onları barındıracak.',
    multiscsi: 'TVStor MultiSCSI yol haritasında — bu alan onu barındıracak.',
    clusterFederation: 'TVirt kümeleri arasındaki federasyon yol haritasında — bu alan onu barındıracak.',
    containersOciImages: 'OCI görüntüleri yol haritasında — bu alan onları barındıracak.',
    containersOciRegistries: "OCI registry'leri yol haritasında — bu alan onları barındıracak.",
    containersCtTemplates: 'CT şablonları yol haritasında — bu alan onları barındıracak.',
    importVms: "ESXi ve Proxmox importer'ları buraya gelecek: konuk dönüştürme ve TVirt'e toplu geçiş.",
    backup: 'Tümleşik yedekleme 6.2 ile geliyor: veri tekilleştirmeli content-addressed depolar, CBT artımlıları, değiştirilemezlik pencereleri ve repo-to-repo replikasyon.',
    monitoring: "Küme genelinde çekişme dashboard'ları (cpu.ready, PSI baskısı, yerleşik alert'ler) yolda — bugün aynı metrikler her VM'nin ayrıntılarında yaşıyor."
  },
  home: {
    welcome: 'Şu hesapla oturum açtınız: {name}',
    subtitle: 'TVirt kümeniz tek bakışta.',
    loadError: 'Genel bakış yüklenemedi — TVirt arka ucu erişilebilir mi?',
    health: {
      ok: 'Her şey yolunda',
      warning: 'Dikkat',
      critical: 'Kritik sorunlar'
    },
    reason: {
      'node-down': '{subject} kapalı',
      'node-stale': '{subject} bir süredir ses vermiyor',
      'node-maintenance': '{subject} bakımda',
      'tasks-failed': {
        one: 'son 24 saatte {n} görev başarısız oldu',
        other: 'son 24 saatte {n} görev başarısız oldu'
      },
      'storage-degraded': '{subject} depolaması bozulmuş durumda',
      'storage-error': '{subject} depolaması hata durumunda',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': "küme store'una erişilemiyor",
      'license-absent': "lisans yok — yeni VM'ler başlatılamaz",
      'license-expired': "lisansın süresi doldu — yeni VM'ler başlatılamaz",
      'license-exceeded': "lisans sınırı aşıldı — yeni VM'ler başlatılamaz",
      'failover-reserve-eroded': 'yük devretme rezervi neredeyse tükendi',
      'failover-reserve-exhausted': "yük devretme rezervi tükendi — yeni VM'ler başlatılamaz",

      'oci-cache-nearly-full': "{subject} üzerinde OCI önbelleği neredeyse dolu — digest'ler elle çıkarılır",
      'oci-cache-full': "{subject} üzerinde OCI önbelleği dolu — digest'ler çıkarılana kadar hiçbir pull başarılı olmaz",
      'config-replica-empty': '{subject} üzerindeki yapılandırma replikası BOŞ — bir replikasyon başarılı olana kadar düğümde küme yapılandırması yok',
      'config-replica-stalled': '{subject} üzerinde yapılandırma replikasyonu durdu — yerel kopya küme yapılandırmasının gerisinde kalıyor'
    },
    staleChip: 'Veriler güncel değil',
    staleAsOf: 'son replikasyon {time}',
    zone: {
      nodes: 'Düğümler',
      failoverReserve: 'Yük devretme rezervi',
      capacity: 'Kapasite',
      workload: 'İş yükü',
      protection: 'Koruma',
      activity: 'Son etkinlik'
    },

    // Zona riserva di failover (admission control N+1, task #133b).
    reserve: {
      state: {
        ok: 'Rezerv sağlam',
        eroded: 'Rezerv neredeyse tükendi',
        exhausted: 'Rezerv tükendi',
        unknown: 'Rezerv bilinmiyor'
      },
      tolerate: {
        one: '{n} düğüm kaybını tolere eder',
        other: '{n} düğüm kaybını tolere eder'
      },
      usedOf: '{used} / {allowed} GiB kullanımda',
      keepFree: 'yük devretme için {n} GiB boş tutuluyor',
      expendable: 'bunun {n} kadarı hizmet sırasında feda edilebilir',
      headroom: 'daha {n} GiB başlatılabilir',
      short: "rezervde {n} GiB eksik — yeni VM'ler başlatılamaz",

      // Huge pages per taglia (ratifica 2026-08-04) — forma etichetta-due punti.
      hp: {
        usedOf: '{size} boyutlu sayfalar — kullanımda: {used} / {allowed}',
        keepFree: 'yük devretme için boş tutulan: {keep}',
        headroom: 'daha başlatılabilir: {n}',
        short: "rezervdeki eksik: {n} — büyük sayfalı yeni VM'ler başlatılamaz"
      },
      worstCase: 'en kötü durum: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Henüz hiçbir düğüm belleğini bildirmedi — rezerv hesaplanamıyor ve hiçbir başlatma reddedilmiyor.',
      reason: {
        attestedDown: 'kapalı beyan edildi',
        maintenance: 'bakımda',
        unreachable: 'erişilemiyor',
        capacityUnknown: 'bellek bildirilmedi'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} çekirdek / {threads} iş parçacığı',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} etkin VM',
        other: '{n} etkin VM'
      },
      activeVmsUnknown: 'etkin VM sayısı bilinmiyor',
      lastSeen: '{time} görüldü',
      neverSeen: 'hiç görülmedi',
      down: 'Kapalı',
      maintenance: 'Bakım',
      stale: 'Erişilemiyor'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB sağlanmış',
      reserve: 'rezerv {n} GiB',
      unobserved: 'kapasite henüz gözlemlenmedi',
      empty: 'Henüz depolama yok'
    },
    workload: {
      vms: 'Sanal makineler',
      apps: "App'ler",
      services: 'Ağ hizmetleri',
      empty: 'Henüz yok',
      phasesUnknown: 'aşamalara göre dağılım mevcut değil'
    },
    protection: {
      none: 'Yapılandırılmış yedek hedefi yok — yapılandırmanızı koruyun.',
      configure: 'Checkpointleri yapılandır',
      noRuns: 'Henüz hiç checkpoint oluşturulmadı.',
      last: 'Son checkpoint',
      onTarget: '{target} üzerinde',
      viewAll: 'Checkpointler'
    },
    activity: {
      empty: 'Son etkinlik yok',
      failed24: {
        one: '24 saatte {n} başarısız',
        other: '24 saatte {n} başarısız'
      },
      viewAll: 'Tüm görevleri gör'
    }
  },
  notes: {
    title: 'Notlar',
    tabEdit: 'Düzenle',
    tabPreview: 'Önizleme',
    placeholder: 'Serbest operatör notları — Markdown önizlemede işlenir',
    empty: 'Not yok',
    tooLarge: 'Notlar 64 KiB sınırını aşıyor',
    saveError: 'Notlar kaydedilemedi'
  },
  common: {

    // Round «errori onesti» (2026-08-03): un 200 illeggibile non è rete giù.
    contractError: 'Arka uç yanıtı, bu arayüzün tanımadığı bir değer içeriyor: {field}={value} — web arayüzünü arka uç sürümüne güncelleyin.',
    contractErrorItems: 'Bu listedeki {count} nesne bu arayüz tarafından okunamıyor ({field}={value}) ve gösterilmiyor.',
    staleHint: "Store'a erişilemiyor — gösterilen, bu düğümün config replikasıdır; filonun durumu bilinmiyor.",
    staleStateAge: 'durum: {time}',
    staleStateNever: "durum store'dan hiç alınmadı: yalnızca bu düğümün kendi gözlemlerini görüyorsunuz",
    staleStateTooltip: "Küme store'una erişilemiyor: gözlenen durum (evre, düğüm, ajan) bu düğümün durum replikasından gelir ve store'dan yapılan son başarılı okumaya dayanır — güncelliğini yitirmiş olabilir.",
    noPermission: 'Bu eylem için izniniz yok',

    // Budget di attesa scaduto ≠ esito (Luca 2026-08-06).
    actionStillRunning: 'Eylem hâlâ devam ediyor: sonucu henüz bilinmiyor',
    staleWrite: 'Siz düzenlerken bu nesneyi başka biri değiştirdi — hiçbir şey yazılmadı. Yeniden yükleyin ve değişikliği güncel durum üzerinde tekrarlayın.',
    staleReload: 'Yeniden yükle',
    preview: 'Önizleme',
    previewTitle: 'Sonucun önizlemesi',
    previewNothingWritten: 'Sunucuda simüle edildi — hiçbir şey yazılmadı.',
    previewChanged: 'Vurgulananlar: değişecek olan değerler.'
  },
  context: {
    copySelection: 'Seçili metni kopyala'
  },
  crud: {
    create: 'Oluştur',
    viewDetails: 'Ayrıntıları gör',
    viewOrEdit: 'Gör veya düzenle',
    selected: 'seçili',
    viewUsingVms: "Bu kaynağı kullanan VM'leri gör",
    clearSelection: 'Seçimi temizle',
    deleteSelected: 'Seçilenleri sil',
    bulkConfirmBody: {
      one: 'Seçili {count} öğe silinsin mi? Korumalı olanlar bildirilir ve tutulur.',
      other: 'Seçili {count} öğe silinsin mi? Korumalı olanlar bildirilir ve tutulur.'
    },
    bulkDeleted: 'silindi',
    bulkRefused: 'reddedildi',
    fieldId: 'ID',
    createdAt: 'Oluşturulma',
    updatedAt: 'Güncellenme',
    immutableField: 'Oluşturma sırasında sabitlenir — contract değiştirilmesine izin vermez',
    immutableScope: 'Scope oluşturma sırasında atanır; bazı kaynaklar özel bir eylemle taşınır',
    observedField: 'Gözlemlenen durum — platform tarafından raporlanır, düzenlenemez'
  }
}
